import { render, staticRenderFns } from "./RankItem.vue?vue&type=template&id=08194a44&scoped=true"
import script from "./RankItem.vue?vue&type=script&lang=js"
export * from "./RankItem.vue?vue&type=script&lang=js"
import style0 from "./RankItem.vue?vue&type=style&index=0&id=08194a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08194a44",
  null
  
)

export default component.exports